import api from '@/api/api-endpoints'
import { createAsyncMutation, doAsyncGet } from '@/api/async-util'

const types = {
    GET_PRODUCT_CATEGORIES: createAsyncMutation('GET_PRODUCT_CATEGORIES'),
    GET_PRODUCT_EDITIONS: createAsyncMutation('GET_PRODUCT_EDITIONS'),
    GET_PRODUCT_LINES: createAsyncMutation('GET_PRODUCT_LINES'),
    GET_PRODUCT_VERSIONS: createAsyncMutation('GET_PRODUCT_VERSIONS'),
    GET_PRODUCT_LINES_FOR_LEGACY_ACTIVATION_RETRIEVAL: createAsyncMutation('GET_PRODUCT_LINES_FOR_LEGACY_ACTIVATION_RETRIEVAL'),
    GET_PRODUCTS_FOR_ACTIVATION: createAsyncMutation('GET_PRODUCTS_FOR_ACTIVATION'),
    GET_PRODUCTS_FOR_PURCHASE: createAsyncMutation('GET_PRODUCTS_FOR_PURCHASE'),
}

const product = {
    state: {},
    mutations: {},
    actions: {
        // GET
        getProductCategories(store) {
            let url = api.productCategory
            return doAsyncGet(store, { url, mutationTypes: types.GET_PRODUCT_CATEGORIES })
        },
        getProductLinesForLegacyActivationRetrieval(store) {
            let url = api.product + 'LegacyActivationRetrievalProducts'
            return doAsyncGet(store, { url, mutationTypes: types.GET_PRODUCT_LINES_FOR_LEGACY_ACTIVATION_RETRIEVAL })
        },
        getProductsForActivation(store) {
            let url = api.product + 'ActivationList'
            return doAsyncGet(store, { url, mutationTypes: types.GET_PRODUCTS_FOR_ACTIVATION })
        },
        getProductsForPurchase(store, payload) {
            let url = api.product + 'PurchaseList'
            if (payload) url += '?productCategoryId=' + payload.id
            else url += '?productCategoryId='
            return doAsyncGet(store, { url, mutationTypes: types.GET_PRODUCTS_FOR_PURCHASE })
        },

        getProductLines(store) {
            let url = api.productLine
            return doAsyncGet(store, { url, mutationTypes: types.GET_PRODUCT_LINES })
        },
        getProductEditions(store) {
            let url = api.product + 'Editions'
            return doAsyncGet(store, { url, mutationTypes: types.GET_PRODUCT_EDITIONS })
        },
        getProductVersions(store) {
            let url = api.product + 'Versions'
            return doAsyncGet(store, { url, mutationTypes: types.GET_PRODUCT_VERSIONS })
        },
        // POST

        // PUT

        // DELETE
    },
    getters: {},
    types: types
}

export default product
